<template>
  <div class="home">
    <div class="content">
      <div class="flex relative">
        <ClassifyTree></ClassifyTree>
        <div class="relative">
          <TopNav />
          <div class="line"></div>
          <div class="flex">
            <Banner class="m-x-12"></Banner>
            <User></User>
          </div>
        </div>
        <!--  -->
      </div>
      <AdLine></AdLine>
      <SaleBanner></SaleBanner>
      <HotSale></HotSale>
      <Dynamics @setHomepageList="setHomepageList"></Dynamics>
      <BrandLine class="mt-20"></BrandLine>
    </div>
    <LeftNav ref="leftNav"></LeftNav>
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="600px"
    >
      <QueryCurrentUserPlcCompany
        @cancel="dialogVisible = false"
        v-if="dialogVisible"
        :list="list"
      />
    </el-dialog>
  </div>
</template>

<script>
import TopNav from "./components/topNav.vue";
import ClassifyTree from "./components/classifyTree.vue";
import Banner from "./components/banner.vue";
import User from "./components/user.vue";
import AdLine from "./components/adLine.vue";
import HotSale from "./components/hotSale.vue";
import Dynamics from "./components/dynamics.vue";
import BrandLine from "./components/brandLine.vue";
import LeftNav from "./components/leftNav.vue";
import QueryCurrentUserPlcCompany from "./components/queryCurrentUserPlcCompany.vue";
import { getAccessToken } from "@/utils/userInfo";
import SaleBanner from './components/saleBanner.vue';

export default {
  components: {
    TopNav,
    ClassifyTree,
    Banner,
    User,
    AdLine,
    HotSale,
    Dynamics,
    BrandLine,
    LeftNav,
    QueryCurrentUserPlcCompany,
    SaleBanner,
  },
  data() {
    return {
      dialogVisible: false,
      list: [],
    };
  },
  created() {
    this.queryCurrentUserPlcCompany();
  },
  methods: {
    setHomepageList(list) {
      this.$refs.leftNav.setDynamicsList(list);
    },
    handleClose() {
      sessionStorage.setItem("plcTip", "1");
      this.dialogVisible = false;
    },
    queryCurrentUserPlcCompany() {
      if (!getAccessToken() || sessionStorage.getItem("plcTip") === "1") {
        return;
      }
      this.$http
        .get("/front/oms/plc/user/queryCurrentUserPlcCompany")
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data || [];
            if (this.list.length > 0) {
              this.dialogVisible = true;
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  justify-content: center;
  position: relative;
  .content {
    width: 1200px;
  }
  .m-x-12 {
    margin-left: 12px;
    margin-right: 12px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .line {
    position: absolute;
    width: 99%;
    height: 2px;
    background-color: rgba(42, 84, 209, 0.4);
    z-index: 10;
    top: 44px;
    left: 1%;
  }
  .relative {
    position: relative;
  }
}
</style>
